<template>
  <div v-if="error" class="div"
       style="position: absolute;background:red; color:white;bottom:0;width:100%;padding:20px;z-index: 100">{{
      error
    }}
  </div>
  <div class="relative" style="z-index: 10;position: relative">
  <pa-shaka v-if="videoUrl" :manifestUrl="videoUrl" :posterUrl="'images/4k-banner.png'"
            @playing="onPlaying"
  ></pa-shaka>
  </div>
  <div v-if="!playing" style="position: absolute;left:0px;top:0px;width:100%;height: 100%; z-index:10000000">
    <img src="images/4k-banner.png"  alt="" style="width: 100%; height: 100%;">
    <div style="position:absolute;z-index:10; left:0px; bottom:10%;font-size: 50px;font-weight: bold;width: 100%;text-align: center">Loading Channel...</div>
  </div>
</template>
<script>
import PaShaka from "@/components/shaka.vue";

export default {
  name: 'pa-stream',
  components: {PaShaka},
  data() {
    return {
      playing:false,
      videoUrl: '',
      error: null
    }
  },
  methods: {
    onPlaying(){
      console.log('playing');
      this.playing=true;
    },
    load() {
      var videoSrc = this.$route.params.id;
      this.videoUrl = videoSrc;
      if (!videoSrc) {
        videoSrc = localStorage.getItem('stream');
      }
      localStorage.setItem('stream', videoSrc);
    }
  },
  mounted() {
    window.addEventListener('keydown', (e) => {
      this.code = e.keyCode;
      if (e.keyCode == 19) this.pause();
      if (e.keyCode == 179) this.play();
      if (e.keyCode == 228) this.seek();
      if (e.keyCode == 227) this.seekBack();
      if (e.keyCode == 169) {
        this.$router.go(-1);
      }
    })

    // window.addEventListener("online", () => {
    //   this.load();
    //
    // }, false);
    this.load();
  }
}
</script>
